import { Component } from '@angular/core';

@Component({
  selector: 'app-section-institucional',
  templateUrl: './section-institucional.component.html',
  styleUrls: ['./section-institucional.component.scss'],
})
export class SectionInstitucionalComponent {}
